/**
 * description 导航定位
 * created by zhang.yingyu
 * modified on 2018-03-29
 */
"use strict";
angular.module("navPositionModule", [])
    .directive("navPosition", ["$timeout", function($timeout) {
        return {
            scope:{
                cont:"@",
                navBar:'@',
                posPanel:"@",
                scrollContainer:'@'
            },
            restrict: "E",
            replace: false,
            transclude: false,
            link:function(scope,element,attrs){
                $timeout(function(){
                    var navBar=$(element).find(".nav_bar li span");
                    var posPanel=$(element).find(".analysis_detail_panel");
                    var scroll_container= $(".content_text_wrap");
                    get_position(navBar,posPanel,scroll_container);
                    $(".event_go_top")[0].onclick=function(){
                        scroll_container.animate({scrollTop: 0 + "px"}, {duration: 500, easing: "swing"});
                    };
                    function getOffsetTop(obj){
                        var top=obj.offsetTop;
                        while(obj==obj.offsetParent){
                            top+=obj.offsetTop;
                        }
                        return top;
                    }
                    function get_position(nav,item,container){
                        for(var i=0;i<nav.length;i++){
                            nav[i].onclick=function(){
                                for (var j = 0; j < nav.length; j++) {
                                    if (this == nav[j]) {
                                        // 根据点击元素获取页面元素的高
                                        var top=getOffsetTop(item[j])+46;
                                        if($(nav[j]).hasClass("basic_info_s")){
                                            top=0;
                                        }
                                        //页面滚动动画
                                        container.animate({scrollTop: top + "px"}, {duration: 500, easing: "swing"});
                                        return false;
                                    }
                                }
                            }
                        };
                        //容器滚动定位
                        container.scroll(function() {
                            var num=0;
                            $(".event_analysis_nav_bar").hide();
                            if(container.scrollTop()>$(".panel1").height()-20){
                                $(".event_analysis_nav_bar").show();
                            }
                            for (var i = 0; i < item.length; i++) {
                                if (container.scrollTop()>item[i].offsetTop) {
                                    num = i;
                                }
                                $(nav[i]).removeClass("active");
                            }

                            $(nav[num]).addClass("active");
                        });
                    };
                });


            }
        }
    }]);